import * as React from "react";
import formatDate from "dateformat";
import {
  ResponsiveContainer,
  LineChart,
  YAxis,
  XAxis,
  Line,
  Tooltip,
  Legend,
  CartesianGrid,
} from "recharts";
import { transparentize } from "polished";
import { CovidCaseByCountry_covidCaseOwidByCountry_data } from "../../../apollo-types/CovidCaseByCountry";
import { TooltipContainerStyles } from "../../design-tokens/charts";
import { formatNumberDisplay } from "../../../utils/format-number";
import { Colors } from "../../design-tokens/colors";
import { AskAboutContext } from "../../../site-context/ask-about-context";
import styles from "./daily-cases-chart.styles";

interface KeyToPlot {
  key: string;
  name: string;
  color: string;
  isMainSeries?: boolean;
  unit?: string;
}

interface DailyCasesChartProps {
  data: CovidCaseByCountry_covidCaseOwidByCountry_data[];
  keysToPlot: KeyToPlot[];
}

const DailyCasesChart: React.FC<DailyCasesChartProps> = ({
  data,
  keysToPlot,
}) => {
  const {
    store: { isMobile },
  } = React.useContext(AskAboutContext);
  const mainSeries = keysToPlot.find((k) => k.isMainSeries);
  const mainKey = mainSeries?.key;
  const firstDataIndex = mainKey ? data.findIndex((d: any) => d[mainKey]) : 0;
  const dataToPlot = data.slice(firstDataIndex, data.length);

  return (
    <div css={styles.container}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={dataToPlot}>
          <CartesianGrid
            vertical={false}
            stroke={transparentize(0.7, Colors.MidGrey)}
          />
          <YAxis
            domain={["auto", "auto"]}
            tickLine={false}
            minTickGap={20}
            axisLine={false}
            width={isMobile ? 45 : 52}
            tickFormatter={formatNumberDisplay}
            unit={mainSeries?.unit}
          />
          <XAxis
            dataKey="date"
            height={50}
            tickLine={false}
            axisLine={false}
            tickMargin={15}
            tickFormatter={(date) => formatDate(date, "mmm d")}
          />

          {keysToPlot.map((key) => (
            <Line
              key={key.key}
              type="monotone"
              dataKey={key.key}
              name={key.name}
              stroke={key.color}
              strokeWidth={key.isMainSeries ? 3 : 2}
              dot={false}
              activeDot={{
                r: key.isMainSeries ? 5 : 4,
                strokeWidth: 0,
              }}
              unit={key.unit}
            />
          ))}

          <Tooltip
            labelFormatter={(date) => formatDate(date, "mmm d")}
            cursor={false}
            contentStyle={TooltipContainerStyles}
            itemStyle={{ paddingBottom: 0 }}
          />
          <Legend />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DailyCasesChart;
